export const accountTypes = {
    USER_DATA_REQUEST: 'User data lodaing',
    USER_DATA_SUCCESS: 'User data loading successfully',
    USER_DATA_ERROR: 'User data loading successfully',

    USER_DATA_CHANGE_REQUEST: 'Change user data in progress',
    USER_DATA_CHANGE_SUCCESS: 'Change user data - success',
    USER_DATA_CHANGE_ERROR: 'Change user data - error',

    USER_PASSWORD_CHANGE_REQUEST: 'User password change in progress',
    USER_PASSWORD_CHANGE_SUCCESS: 'User password change success',
    USER_PASSWORD_CHANGE_ERROR: 'User password change error',

    USER_SUBSCRIPTIONS_REQUEST: 'User subscriptions loading',
    USER_SUBSCRIPTIONS_SUCCESS: 'User subscriptions ready',
    USER_SUBSCRIPTIONS_ERROR: 'User subscriptions problems',
    USER_SUBSCRIPTIONS_CHANGE_REQUEST: 'User subscriptions request to save',
    USER_SUBSCRIPTIONS_CHANGE_SUCCESS: 'User subscriptions saved',
    USER_SUBSCRIPTIONS_CHANGE_ERROR: 'User subscriptions not saved',

    CLEAR: 'User clear',
};
